import { render, staticRenderFns } from "./add-giftsetsalert-popup.vue?vue&type=template&id=6b497270"
import script from "./add-giftsetsalert-popup.vue?vue&type=script&lang=js"
export * from "./add-giftsetsalert-popup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports